import React, {useState, useEffect} from "react";
import { motion, AnimatePresence } from 'framer-motion';
import { phpPath } from "./config"; // adjust path if needed
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";

const Workouts = () => {

    const imagePath = "/images/products/";
    const navigate = useNavigate();

    const [pageNumber, setPageNumber] = useState(1); // #added 4/4/25 TG
    const [itemsPerPage, setItemsPerPage] = useState(12); // #added 4/4/25 TG
    const [display, setDisplay] = useState("items"); // #added 4/4/25 TG
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [products, setProducts] = useState([]); // #added 4/4/25 TG

    // #state

    /*const products = [
      {
        product_id: 1,
        name: "Kettlebell",
        mainImage: `${imagePath}kettlebell-1.png`,
        images: [
          `${imagePath}kettlebell-1.png`,
          `${imagePath}kettlebell-2.png`,
          `${imagePath}kettlebell-3.png`,
        ],
        price: "$49.99",
        stock: 10,
        description: `
          <p><strong>A high-quality kettlebell</strong> for strength training.</p>
          <ul>
            <li>Ergonomic grip</li>
            <li>Rust-resistant finish</li>
            <li>Available in multiple weights</li>
          </ul>
          <p>💪 Perfect for beginners and pros alike.</p>
        `,
      },
      {
        product_id: 2,
        name: "Dumbbell",
        mainImage: `${imagePath}dumbbells-1.png`,
        images: [
          `${imagePath}dumbbells-1.png`,
          `${imagePath}dumbbells-2.png`,,
          `${imagePath}dumbbells-3.png`,
        ],
        price: "$29.99",
        stock: 5,
        description: `
          <p><strong>Adjustable dumbbells</strong> designed for compact home gyms.</p>
          <p>Features:</p>
          <ol>
            <li>Quick-lock system</li>
            <li>Rubber-coated handles</li>
            <li>Up to 25 lbs each</li>
          </ol>
        `,
      },
      {
        product_id: 3,
        name: "Musculos",
        mainImage: `${imagePath}muscles-1.png`,
        images: [
          `${imagePath}muscles-1.png`,
          `${imagePath}muscles-2.png`,
          `${imagePath}muscles-3.png`,
        ],
        price: "$29.99",
        stock: 20,
        description: `
          <p>Premium resistance bands to build muscle.</p>
          <p><em>Includes light, medium, and heavy options</em>.</p>
        `,
      },
    ];*/
    

    const fetchProductDetails = (product_id) => {
      const product = products.find(p => p.product_id === product_id);
      if (product) {
        setSelectedProduct(product);
        setSelectedImage(product.mainImage); // 🆕
        setDisplay('product');
      }
    };
    
  
    const handleBack = () => {
      setDisplay('items');
      setSelectedProduct(null);
    };
  
    useEffect(() => {
      const fetchProducts = async () => {
        try {
          const res = await fetch(`${phpPath}/get_products.php`, {
            method: 'POST'
          });
          const data = await res.json();
          setProducts(data);
        } catch (err) {
          console.error("Error fetching products:", err);
        }
      };
    
      fetchProducts();
    }, []);

    const handleClick = () => {

    }

    //------------------------------------
    // JSX
    //------------------------------------
    return (
      <div>
        <main>
          <AnimatePresence mode="wait">
            {/* #Items List */}
            {display === "items" && (
              <motion.div
                key="items-view"
                initial={{ opacity: 0, x: -40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 40 }}
                transition={{ duration: 0.4 }}
              >
                <section id="workouts" className="section overlay tint-black-30 height-40vh">
                  <div className="section__content">
                    <h2 className="general-title">Workouts</h2>
                    <h2 className="font-size-20 color-gray-3">
                      start burning up those evil calories right away!
                    </h2>
                  </div>
                </section>
    
                           {/* #Who Am I */}
            <section className="section bg-color-gray-12 noheight padding-bottom-100">
            <div className="section__content  margin-top-140">
                <div className="gdiv width-80 gap-10px">
                <h2 className="general-title text-align-left move-left text-shadow">
                    Free workouts
                </h2>
                <div className="general-description text-align-left move-left text-shadow margin-top-20">
                    Get our free workouts:
                <ol>
                    <li className="margin-top-40">
                    Go to our App by <a href="https://eleven.fit/timer/workouts" target="_blank" className="link">clicking here</a>.
                    <ul class="sublist">
                        <li>No installation needed.</li>
                        <li>But... you can install it if you like!</li>
                    </ul>
                    </li>
                    <li className="margin-top-40">
                    Create a user.
                    <ul class="sublist">
                        <li>Go to the top right section where it says "Register / Log In" </li>
                        <img src="./images/site/register-on-app-TG.png" alt="Register" className="img-responsive" />
                        <li className="margin-top-20">It’s <em>optional</em>, <strong>but</strong> you'll be able to save your sessions and have extra strength during your workouts.</li>
                        <li>Also, the statistics say that the fittest people do register<span class="emoji">🔥</span></li>
                    </ul>
                    </li>
                    <li className="margin-top-40">Go to Open Workout.{/*TG */}
                      <img src="./images/site/open-workout.png" alt="Open Workout" className="img-responsive margin-top-10" />
                      </li>
                    <li className="margin-top-40">Choose from All Public Workouts {/*TG  TG*/}
                    <ul class="sublist">
                        <li>Check that  the title says "All Public Workouts", if not, see the step below. </li>
                        <img src="./images/site/all-public-workouts.png" alt="Register" className="img-responsive" />
                        <li className="margin-top-20">Click Explore More Workouts. Then you will be able to browse All Public Workouts.</li>
                        <img src="./images/site/explore-more-workouts.png" alt="Register" className="img-responsive" />
                    </ul>
                    </li>
                </ol>
                </div>
                </div>


                <div className="gdiv width-80 gap-10px margin-top-100">
                <h2 className="general-title text-align-left move-left text-shadow">
                    Program & Workout Packs
                </h2>
                <div className="general-description text-align-left move-left text-shadow margin-top-20">
                  
                  
                <div className="responsive-player-wrapper margin-left-0">
                  <ReactPlayer
                    url="https://www.youtube.com/watch?v=6P7Ngrsplw8"
                    playing
                    loop
                    muted
                    width="100%"
                    height="100%"
                    className="react-player-2"
                  />
                </div>
                  <p>You can get our main functional fitness program that will get you sweating in 10 seconds or less. Just go to our "Plan" section by clicking the button below. </p>
                  <p className="margin-top-20">We also offer a variety of workout packs that range from hypertrophy, to intense, to Abs, Calorie Burners, and much more delighful pleasures!</p> 
                
                </div>
                <button className="button-2 move-left margin-top-10" onClick={()  => {navigate('/Program')}}>
                  Go to Program & Packs
                </button>

                </div>
            </div>
            </section>



              </motion.div>
            )}
    

          </AnimatePresence>
        </main>
      </div>
    );
    
};

export default Workouts;